import ScrollArea from '@/components/common/ScrollArea';

/**
 * Mixin for the settings section that handles business prop and changes on it.
 * Every component whis is using this mixin must implement businessChangedCallback method called from this mixin every time a business prop changes.
 */
export default {
  components: {
    ScrollArea,
  },
  props: {
    business: {
      type: Object,
      required: false,
      default: () => { },
    },
  },
  watch: {
    business() {
      this.businessChangedCallback();
    },
  },
  mounted() {
    // in case user returns to the page. On first mount business is undefined so this will not trigger
    if (this.business.id) {
      this.businessChangedCallback();
    }
  },
};
